import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AsyncJobsProgressDisplayComponent } from './async-jobs-progress-display.component';

@NgModule({
  declarations: [AsyncJobsProgressDisplayComponent],
  imports: [CommonModule],
  exports: [AsyncJobsProgressDisplayComponent],
})
export class AsyncJobsProgressDisplayModule {}
